import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import BottomNav from '../components/layout/bottomNav';
import RatingPopup from '../pages/ratingPopup';
import './events.css';

import mirnaImg from '../assets/imgs/mirna.png';
import haramLogo from '../assets/icons/karmaLogo.svg';
import MobileHeader from '../components/layout/mobileHeader';

const Events = () => {
  const navigate = useNavigate();

  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState('2027-01-31');
  const [showRating, setShowRating] = useState(false);

  useEffect(() => {
    const loadEvents = async () => {
      const { data, error } = await supabase
        .from('scheduled_events')
        .select('*')
        .order('event_date', { ascending: true });

      if (error) {
        console.error('Events load failed:', error.message);
        navigate('/Error404');
        return;
      }

      setEvents(data || []);
    };

    loadEvents();

    const timer = setTimeout(() => {
      setShowRating(true);
    }, 7000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const eventDates = useMemo(() => {
    return events.map((event) => event.event_date);
  }, [events]);

  const selectedEvents = events.filter(
    (event) => event.event_date === selectedDate
  );

  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const handleDateClick = (day) => {
    const date = `2027-01-${String(day).padStart(2, '0')}`;

    if (eventDates.includes(date)) {
      setSelectedDate(date);
    } else {
      navigate('/ComingSoon');
    }
  };

  return (
    <main className="eventsPage">
        <MobileHeader />

      <section className="calendarBox">
        <div className="calendarTop">
          <button>‹</button>
          <h1>January 2027</h1>
          <button>›</button>
        </div>

        <div className="weekDays">
          <span>M</span>
          <span>T</span>
          <span>W</span>
          <span>T</span>
          <span>F</span>
          <span>S</span>
          <span>S</span>
        </div>

        <div className="calendarGrid">
          <span></span>
          <span></span>
          <span></span>
          <span></span>

          {days.map((day) => {
            const date = `2027-01-${String(day).padStart(2, '0')}`;
            const hasEvent = eventDates.includes(date);
            const isSelected = selectedDate === date;

            return (
              <button
                key={day}
                onClick={() => handleDateClick(day)}
                className={`
                  calendarDay 
                  ${hasEvent ? 'hasEvent' : 'disabledDay'}
                  ${isSelected ? 'selectedDay' : ''}
                `}
              >
                {day}
              </button>
            );
          })}
        </div>
      </section>

      <section className="eventsCards">
        {selectedEvents.map((event) => (
          <div className="eventCardMobile" key={event.id}>
            <img
              src={event.image_url || mirnaImg}
              alt={event.speaker || event.title}
              className="eventPerson"
            />

            <div className="eventInfo">
              <h2>{event.title}</h2>
              <h3>{event.speaker}</h3>
              <p>
                On Saturday, January {new Date(event.event_date).getDate()}
              </p>
              <span>From {formatTime(event.event_time)}</span>
            </div>

            <img
              src={event.logo_url || haramLogo}
              alt="Event logo"
              className="eventLogo"
            />
          </div>
        ))}
      </section>

      {showRating && <RatingPopup onClose={() => setShowRating(false)} />}

      <BottomNav activePage="events" />
    </main>
  );
};

function formatTime(time) {
  if (!time) return '';
  const [hour, minute] = time.split(':');
  const date = new Date();
  date.setHours(hour);
  date.setMinutes(minute);

  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
}

export default Events;